// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminFooter-adminFooterContainer-pBV8K {
    margin-left: var(--siteAdmin-sideBar-width);
    margin-top: 50px;
    position: fixed;
    bottom: 0;
    padding: 15px;
    background: var(--background-primary);
    width: calc(100% - var(--siteAdmin-sideBar-width));
    text-align: center;
    border-top: 1px solid var(--primary-border);
    z-index: 1030;
}

@media (max-width: 1199px) {
    .AdminFooter-adminFooterContainer-pBV8K {
        width: 100%;
        margin-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/AdminFooter/AdminFooter.css"],"names":[],"mappings":"AAAA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,kDAAkD;IAClD,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,cAAc;IAClB;AACJ","sourcesContent":[".adminFooterContainer {\n    margin-left: var(--siteAdmin-sideBar-width);\n    margin-top: 50px;\n    position: fixed;\n    bottom: 0;\n    padding: 15px;\n    background: var(--background-primary);\n    width: calc(100% - var(--siteAdmin-sideBar-width));\n    text-align: center;\n    border-top: 1px solid var(--primary-border);\n    z-index: 1030;\n}\n\n@media (max-width: 1199px) {\n    .adminFooterContainer {\n        width: 100%;\n        margin-left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminFooterContainer": `AdminFooter-adminFooterContainer-pBV8K`
};
module.exports = ___CSS_LOADER_EXPORT___;
